module.exports = __webpack_public_path__ + "ca5d900bf443b7a5da68e06255db0643.MP3";